<template>
  <!--<div class="popup popup-firstLevelEnterprise">-->
  <div>
    <div class="hd research-background-color">
      <div class="outer">
        <span class="header_title">科室搜索</span>
        <svg class="arrow_down" @click="$emit('toggleShow')" width="6.5vw" height="6.5vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z" fill="#ffffff" /></svg>
      </div>
      <div class="block_input">
        <div class="wrap" @click="autofocus">
          <label class="icon icon-search icon_2" for="search-department"></label>
          <input class="icon_2" v-model.trim="query" type="search" id='search-department' placeholder='请输入科室名称'/>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="outer_3">
        <div class="outer_attr" v-for="(enterprise, index) in filteredData" :key="index">
          <div class="group" @click="updateEnterprise(enterprise)">
            <div class="attr_name">{{enterprise.enterpriseName}}</div>
            <div class="block">
            </div>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import {mapGetters, mapState, mapMutations} from 'vuex'
  import $ from 'jquery'
  // import EMKT from '../../../../emkt'
  export default {
    data () {
      return {
        query: '',
        data: [],
        filteredData: []
      }
    },
    props: [
      'enterpriseNo'
    ],
    mounted () {
      this.fetchData()
    },
    watch: {
      // listening to input
      'query': function (query) {
        this.initialize()
        let data = this.data
        let filteredData = []
        for (let enterprise of data) {
          if (enterprise.enterpriseName.match(query.toLowerCase())) {
            filteredData.push(enterprise)
            if (filteredData.length > 19) {
              break
            }
          }
        }
        this.filteredData = filteredData
      }
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      updateEnterprise (enterprise) {
        this.$emit('toggleShow')
        this.$emit('update', enterprise)
      },
      fetchData () {
        // 获取科室列表
        if (!this.enterpriseNo) return
        this.gcapi('getSecondEnterpriseInfoByFirstEnterpriseNo', this.enterpriseNo).then((res) => {
          if (res && res.body.result) {
            this.data = res.body.result.filter(enterprise => {
              return enterprise.parentEnterpriseName && enterprise.enterpriseName && enterprise.enterpriseName.includes(enterprise.parentEnterpriseName)
            })
            this.initialize()
          }
        })
      },
      initialize () {
        this.filteredData = this.data
      },
      autofocus () {
        $('#search-department').focus()
      }
    }
  }
</script>
<style scoped>
  .box {
    /*display: flex;*/
    position: absolute;
    /*align-items: center;*/
    /*flex-direction: column;*/
    background-color: #ffffff;
    width: 100vw;
    height: calc(100vh - 30vw);
    top: 29.87vw;
    overflow: scroll;
  }
  .arrow_down {
    margin-left: 27vw;
    /* width: 2.67vw;
    height: 1.73vw; */
  }

  .hd {
    display: flex;
    position: fixed;
    top:0;
    left:0;
    align-items: flex-start;
    flex-direction: column;
    /*background-color: #5878fa;*/
    width: 100vw;
    height: 29.87vw;
    z-index: 10;
  }
  .outer {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 16vw;
  }
  .header_title {
    opacity: 1;
    margin-left: 42vw;
    /*max-width: 44vw;*/
    height: 5.87vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.87vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 4.27vw;
    font-weight: 400;
  }

  .outer_3 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    padding: 2vw 0;
  }
  .outer_attr {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
  }
  /* .outer_3 .outer_attr:last-child .empty{
    width: 73.6vw;
    height: 0.53vw;
    border: 0;
  } */

  .empty {
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(213, 213, 213, 1);
    width: 93vw;
    height: 0.53vw;
  }
  .icon_2 {
    margin-left: 3.73vw;
    outline: none;
    border: none;
    font-size: 3.73vw;
    /* width: 3.73vw;
    height: 3.73vw; */
  }
  .group {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    /* margin-top: 3.47vw; */
    padding-right: 6.4vw;
    padding-left: 6.67vw;
    width: 100vw;
    align-items: center;
    height: 10vw;
  }

  .attr_name {
    opacity: 1;
    width: 7.47vw;
    height: 5.33vw;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.73vw;
    font-weight: bold;
    margin-left: 4vw;
  }

  .container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    /* margin-top: 4vw; */
    width: 100vw;
  }

  .block {
    display: flex;
    align-items: center;
    flex-direction: row;
    /* width: 26.4vw; */
    height: 5.33vw;
  }
  .block_input {
    display: flex;
    flex-direction: row;
    justify-content: center;
    /* margin-top: 5.87vw; */
    width: 99.73vw;
  }

  .wrap {
    display: flex;
    align-items: center;
    flex-direction: row;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 86.67vw;
    height: 9.33vw;
  }

  .icon-search:before {
    font-weight: bold;
    color: #929292;
  }

  input::-webkit-input-placeholder {
    text-align: start;
    color: #D5D5D5;
    font-size: 3.73vw;
  }
  
</style>



// WEBPACK FOOTER //
// DepartmentBox.vue?324ff3f0